import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/css/scrollbar';
import { Swiper as SwiperType } from 'swiper/types';
import styles from './Carousel.module.scss';

interface Props {
  children: React.ReactNode;
  spaceBetween?: number;
  slidesPerView?: number;
  onSlideChange?: (index: number) => void;
  initialSlide?: number;
  autoHeight?: boolean;
}
export function Carousel({ children, spaceBetween, slidesPerView, onSlideChange, initialSlide, autoHeight }: Props) {
  return (
    <Swiper
      modules={[Navigation, Pagination, A11y]}
      spaceBetween={spaceBetween || 50}
      slidesPerView={slidesPerView || 1}
      pagination={{ clickable: true }}
      onSlideChange={(swiper: SwiperType) => {
        if (onSlideChange) {
          onSlideChange(swiper.activeIndex);
        }
      }}
      navigation
      loop
      autoHeight={autoHeight}
      className={styles.swiper}
      initialSlide={initialSlide || 0}
    >
      {children}
    </Swiper>
  );
}

export const CarouselSlide = SwiperSlide;
